import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { PartialResultsDeliveryUpsell } from '@data/tests';
import { NavigationService } from '@services/navigation.service';
import { StorageService } from '@services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class PartialResultsDeliveryGuard implements CanActivate {
  private readonly navigationService = inject(NavigationService);
  private readonly router = inject(Router);
  private readonly storageService = inject(StorageService);

  /**
   * Prevents users from accessing the partial results delivery upsell page if they have already ordered it.
   *
   * @param {ActivatedRouteSnapshot} _route the activated route snapshot (unused)
   * @param {RouterStateSnapshot} state the router state snapshot
   *
   * @returns {boolean | UrlTree} true to allow navigation, or a UrlTree to redirect to the next page
   */
  public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.storageService.orderedTests.some((test) => test.slug === PartialResultsDeliveryUpsell.slug)) {
      return this.router.createUrlTree([this.navigationService.getNextNavigationUrl(state.url)]);
    }

    return true;
  }
}
